import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import divScroll from "@/components/div-scroll/div-scroll.vue";
import { State } from "vuex-class";
let PiMenu = class PiMenu extends Vue {
    constructor() {
        super(...arguments);
        this.theme2 = "light";
        this.openNames = [];
        this.menuList = [];
        this.menuShow = false;
    }
    getVisible() {
        this.openNames = [this.getTowMenu(this.menuId)];
    }
    zoomClick() {
        this.$emit("collapse");
    }
    getTowMenu(key) {
        const arr = key.split("-");
        return arr[0] + "-" + arr[1];
    }
    smallMenuClick(item) {
        if (!item.children || item.children.length == 0) {
            if (this["$route"].path != item.url) {
                this["$router"].push(item.url);
            }
        }
        else {
            item.isOpen = !item.isOpen;
        }
    }
    initMenuList() {
        const menuList = JSON.parse(JSON.stringify(this.sys.menuList));
        menuList.map((item) => {
            item.isOpen = false;
            if (item.children && item.children.length > 0) {
                item.children.map((child) => {
                    child.isOpen = false;
                });
            }
        });
        this.menuList = menuList;
    }
    mounted() {
        this.initMenuList();
    }
};
__decorate([
    Prop({ default: "" })
], PiMenu.prototype, "menuId", void 0);
__decorate([
    Prop({ default: true })
], PiMenu.prototype, "isCollapse", void 0);
__decorate([
    State("sys")
], PiMenu.prototype, "sys", void 0);
__decorate([
    Watch("menuId"),
    Watch("sys.menuList")
], PiMenu.prototype, "getVisible", null);
PiMenu = __decorate([
    Component({
        components: {
            "pi-div-scroll": divScroll,
        },
    })
], PiMenu);
export default PiMenu;
